import { Box, Button, Checkbox, Flex, Form, Radio, Text } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { backend } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { memo } from 'react';

import { fieldNameSelectedCompanies, fieldNameWatchType } from './SlackConnectForm.constants';
import { useSlackConnectForm } from './SlackConnectForm.hooks';
import { messages } from './SlackConnectForm.messages';
import { SlackConnectFormProps } from './SlackConnectForm.types';

export const SlackConnectForm = memo<SlackConnectFormProps>((props) => {
    const { progress } = props;

    const user = useSelector(selectors.profile.findProfileUser);

    const { form, companies, isCompaniesVisible, handleSubmit, handleCancel } = useSlackConnectForm(props);

    if (!user) {
        return null;
    }

    return (
        <Form form={form} onSubmit={handleSubmit}>
            <Flex direction='column' spacing='24'>
                <Text font='headline' fontSize='xsmall' fontWeight='medium' textAlign='center'>
                    {messages.title}
                </Text>

                <Flex direction='column' alignItems='center' spacing='8'>
                    <Text font='label' fontSize='large' fontWeight='regular' textAlign='center'>
                        {messages.description}
                    </Text>

                    <Text font='headline' fontSize='xsmall' fontWeight='medium' textAlign='center'>
                        {user.userEmail}
                    </Text>
                </Flex>

                <Radio.Group name={fieldNameWatchType} size='medium'>
                    <Flex direction='column' spacing='16'>
                        <Radio value={backend.transfers.CompaniesWatchType.All}>{messages.optionWatchAll}</Radio>

                        <Flex direction='column' spacing='8'>
                            <Radio value={backend.transfers.CompaniesWatchType.Selected}>
                                {messages.optionWatchSelected}
                            </Radio>

                            {isCompaniesVisible && (
                                <Box spacing='0 0 8 28'>
                                    <Checkbox.Group
                                        name={fieldNameSelectedCompanies}
                                        direction='column'
                                        spacing='8'
                                        block
                                    >
                                        {companies.map((company) => (
                                            <Checkbox
                                                key={company.id}
                                                value={company.id}
                                                disabled={companies.length === 1}
                                            >
                                                {company.displayName}
                                            </Checkbox>
                                        ))}
                                    </Checkbox.Group>
                                </Box>
                            )}
                        </Flex>
                    </Flex>
                </Radio.Group>

                <Flex direction='column' spacing='16'>
                    <Button size='large' disabled={progress} type='submit'>
                        {messages.buttonAllow}
                    </Button>

                    <Button color='midnight40' size='large' onClick={handleCancel} disabled={progress}>
                        {messages.buttonCancel}
                    </Button>
                </Flex>
            </Flex>
        </Form>
    );
});

SlackConnectForm.displayName = 'SlackConnectForm';
